/** O que o ecrã de arranque diz enquanto espera pela primeira resposta
 *  do servidor. O servidor (plano gratuito do Render) adormece quando
 *  ninguém o usa, e o primeiro pedido depois disso pode levar quase um
 *  minuto: sem explicação, parecia que a plataforma tinha encravado. */
export function textoDoArranque(segundos: number): { titulo: string; detalhe: string | null } {
  if (segundos < 3) return { titulo: 'A carregar…', detalhe: null }
  const detalhe =
    'O servidor adormece quando ninguém o usa durante algum tempo, e o primeiro acesso '
    + 'depois disso pode demorar até um minuto. Não é preciso recarregar a página.'
  if (segundos < 15) return { titulo: 'A acordar o servidor…', detalhe }
  return { titulo: `A acordar o servidor… (${segundos} s)`, detalhe }
}
